import './LoadingIndicator.css';

function LoadingIndicator() {
  return (
    <div className='loader-livestream' />
  );
}

export default LoadingIndicator;
